import log from '@atlassian/jira-common-util-logging/src/log.tsx';
// eslint-disable-next-line jira/import-whitelist
import fetchData from '@atlassian/jira-connect-iframe-legacy/src/services/index.tsx';
// eslint-disable-next-line jira/import-whitelist
import {
	transformUrlToAddonAndModuleKeys,
	extractContext,
} from '@atlassian/jira-connect-iframe-legacy/src/services/transformers.tsx';
import { staticProjectSidebarNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import type { ProjectSidebarNavInfo } from '@atlassian/jira-navigation-apps-resources/src/services/sidebar/project-sidebar-navigation/types.tsx';
import type { RouterDataContext, RouteResourceResponse } from '@atlassian/react-resource-router';

const buildQueryParamsForConnectAPI = async (routerContext: RouterDataContext) => {
	const { query, route, dependencies } = routerContext;
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	const { loading, data, promise, error } = dependencies?.[
		staticProjectSidebarNavigationResource.type
	] as RouteResourceResponse<ProjectSidebarNavInfo>;

	const sidebarData = loading && promise ? await promise : data;
	const projectContext = sidebarData && extractContext(sidebarData);

	if (projectContext == null || error) {
		throw new Error(`Unable to get container context on ${route.name ?? ''} with error ${error}`);
	}
	return { ...query, ...projectContext };
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default async (routerContext: RouterDataContext) => {
	const { query } = routerContext;
	try {
		const { addonKey, moduleKey } = transformUrlToAddonAndModuleKeys(query);
		const queryParams = await buildQueryParamsForConnectAPI(routerContext);
		const data = await fetchData('', addonKey, moduleKey, queryParams);
		return data;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (e: any) {
		log.safeErrorWithoutCustomerData('spa.router.resources.connect.projects', 'fetchData', e);
		throw e;
	}
};
